import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { LrsService } from 'src/app/shared/services/lrs.service';

@Component({
  selector: 'app-segment-inspection-form',
  templateUrl: './segment-inspection-form.component.html',
  styleUrls: ['./segment-inspection-form.component.css'],
})
export class SegmentInspectionFormComponent implements OnInit {
  form: FormGroup;
  projects: { id: number; project_name: string }[] = [];
  routes: { id: number; route_name: string; route_code?: string }[] = [];
  saving = false;

  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private lrs: LrsService,
    private toastr: ToastrMsgService,
    private router: Router
  ) {
    this.form = this.fb.group({
      project_id: [null, Validators.required],
      project_name: [''],
      lrs_route_id: [null],
      segment_code: [''],
      segment_label: ['', Validators.required],
      from_km: [''],
      to_km: [''],
      work_status_summary: [''],
    });
  }

  ngOnInit(): void {
    this.api.getProjectCommonAll({ limit: 500 }).subscribe({
      next: (res: { data?: { id: number; project_name: string }[] }) => {
        this.projects = res.data || [];
      },
    });
  }

  onProjectChange(projectId: number): void {
    const p = this.projects.find((x) => x.id === projectId);
    this.form.patchValue({ project_name: p?.project_name || '' });
    this.routes = [];
    this.form.patchValue({ lrs_route_id: null });
    if (projectId) {
      this.lrs.listRoutes({ project_id: String(projectId) }).subscribe({
        next: (res) => {
          this.routes = res.data || [];
        },
      });
    }
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.saving = true;
    const v = this.form.value;
    this.api
      .createSegmentInspection({
        project_id: v.project_id,
        project_name: v.project_name,
        lrs_route_id: v.lrs_route_id || null,
        segment_code: v.segment_code || null,
        segment_label: v.segment_label,
        from_km: v.from_km || null,
        to_km: v.to_km || null,
        work_status_summary: v.work_status_summary || null,
      })
      .subscribe({
        next: (res: { data?: { id: number }; message?: string }) => {
          this.toastr.success(res.message || 'Created');
          if (res.data?.id) {
            void this.router.navigate(['/home/segment-inspection', res.data.id]);
          } else {
            void this.router.navigate(['/home/segment-inspections']);
          }
        },
        error: (err) => {
          this.saving = false;
          this.toastr.error(err?.error?.message || 'Create failed');
        },
      });
  }

  cancel(): void {
    void this.router.navigate(['/home/segment-inspections']);
  }
}
